/* unplugin-vue-components disabled */import { render } from "./AnimatedPlaceHolder.vue?vue&type=template&id=9d9b3a5a&scoped=true&ts=true"
import script from "./AnimatedPlaceHolder.vue?vue&type=script&lang=ts"
export * from "./AnimatedPlaceHolder.vue?vue&type=script&lang=ts"

import "./AnimatedPlaceHolder.vue?vue&type=style&index=0&id=9d9b3a5a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d9b3a5a"]])

export default __exports__